import { render } from "./PeriodBadge.vue?vue&type=template&id=c15cd03c&scoped=true&ts=true"
import script from "./PeriodBadge.vue?vue&type=script&lang=ts"
export * from "./PeriodBadge.vue?vue&type=script&lang=ts"

import "./PeriodBadge.vue?vue&type=style&index=0&id=c15cd03c&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c15cd03c"]])

export default __exports__